import { Dialog } from '@mui/material'
import React, { useState } from 'react'
import ExportPayoutReports from 'src/clinic/views/clinicBrandPayoutReports/components/ExportPayoutReports'
import ExportTypeSelector from 'src/clinic/views/clinicBrandPayoutReports/components/ExportTypeSelector'
import { PayoutReportExportPaper } from 'src/clinic/views/clinicBrandPayoutReports/styledComponents'
import { EXPORT_TYPES } from 'src/clinic/views/clinicBrandPayoutReports/util'

export default function ExportPayoutReportsDialogWithButton({
  dataFetchingApiUrl,
  startDate,
  endDate,
  entityId,
  entityType,
  eventType,
  allEventTypes,
  fileNamePrefix,
  extraParams,
  payoutReportDataArrayToExcelFormatArrayBuilder,
  useLocalDateFormatForApiCalls = false,
}) {
  const [excelDialogOpen, setExcelDialogOpen] = useState(false)
  const [exportType, setExportType] = useState(EXPORT_TYPES.excel.id)
  function handleSelectExportType(type) {
    setExportType(type)
    setExcelDialogOpen(true)
  }

  return (
    <>
      <ExportTypeSelector handleSelectExportType={handleSelectExportType} />
      <Dialog PaperComponent={PayoutReportExportPaper} open={excelDialogOpen}>
        <ExportPayoutReports
          exportType={exportType}
          closeDialog={() => setExcelDialogOpen(false)}
          dataFetchingApiUrl={dataFetchingApiUrl}
          startDate={startDate}
          endDate={endDate}
          entityId={entityId}
          entityType={entityType}
          eventType={eventType}
          allEventTypes={allEventTypes}
          fileNamePrefix={fileNamePrefix}
          extraParams={extraParams}
          useLocalDateFormatForApiCalls={useLocalDateFormatForApiCalls}
          payoutReportDataArrayToExcelFormatArrayBuilder={
            payoutReportDataArrayToExcelFormatArrayBuilder
          }
        />
      </Dialog>
    </>
  )
}
